import StandardColumn from './standard-column.js';

export default class ReadOnlyColumn extends StandardColumn {
    renderTdContents(record) {
        return record.print(this.field);
    }
}
